/**
 * 실제로 위치가 바뀐 pointermove 만 골라내는 판별기를 만듭니다 (2026-10-31).
 *
 * Windows 는 포인터 모양이 바뀔 때(입체 모드 소프트웨어 커서, 5초 포인터 숨김 등) 움직임 없이도
 * 마우스 이동 신호를 보내고, 입체 모드 소프트웨어 커서(ftgs-stereo-cursor.ts)는 그걸 같은
 * 위치로의 이동으로 다시 내보냅니다. 이걸 움직임으로 치면 "UI·포인터 숨김 → 모양 변경 → 이동
 * 신호 → 다시 보임"이 되풀이돼 글래스 화면에서 재생바가 사라지지 않았습니다.
 *
 * 판별기마다 직전 좌표를 따로 기억하므로, 서로 다른 좌표계의 이벤트(실제 이벤트와 소프트웨어
 * 커서가 다시 보낸 이벤트)를 받는 곳은 각자 하나씩 만들어 씁니다.
 */
const createPointerMoveFilter = () => {
    let lastX = NaN;
    let lastY = NaN;
    return (event: PointerEvent): boolean => {
        if (event.clientX === lastX && event.clientY === lastY) {
            return false;
        }
        lastX = event.clientX;
        lastY = event.clientY;
        return true;
    };
};

export { createPointerMoveFilter };
